import { put, takeEvery, select } from 'redux-saga/effects';

import {
  FILTER_RECEIVE,
  PROPERTY_SEARCH_ACTION,
  propertySearchComplete,
} from '../actions/filter';

const getInputValues = state => ({
  inputValue: state.areas.category.search.inputValue,
  lastInputValue: state.areas.category.search.lastInputValue,
});
const getFilter = state => state.areas.category.filter;

function filterValues(values, loweredInput) {
  const newValues = [];
  values.forEach(val => {
    const filteredChildren = val.children
      ? filterValues(val.children, loweredInput)
      : null;
    if (val.name.toLowerCase().indexOf(loweredInput) >= 0) {
      newValues.push({ ...val });
    } else if (filteredChildren && filteredChildren.length > 0) {
      newValues.push({ ...val, children: filteredChildren });
    }
  });
  return newValues;
}

function includeFilter(filter, loweredInput, values, filteredValues) {
  let visible = false;

  if (
    filter.type &&
    filter.type.indexOf('list') >= 0 &&
    values[filter.id] &&
    values[filter.id].values
  ) {
    filteredValues[filter.id] = {}; // eslint-disable-line no-param-reassign

    const newValues = filterValues(values[filter.id].values, loweredInput);

    if (newValues.length > 0) {
      visible = newValues.length > 0 || visible;
      filteredValues[filter.id].values = newValues; // eslint-disable-line no-param-reassign
    } else {
      filteredValues[filter.id] = { ...values[filter.id] }; // eslint-disable-line no-param-reassign
    }
  } else {
    filteredValues[filter.id] = { ...values[filter.id] }; // eslint-disable-line no-param-reassign
  }

  if (
    filter.name.toLowerCase().indexOf(loweredInput) >= 0 ||
    (filter.unit && filter.unit.toLowerCase().indexOf(loweredInput) >= 0)
  ) {
    visible = true;
  }

  let filteredChildren = null;
  if (filter.children) {
    filteredChildren = filter.children
      .map(child => includeFilter(child, loweredInput, values, filteredValues))
      .filter(x => x);

    visible = filteredChildren.length > 0 || visible;
  }

  return visible ? { ...filter, children: filteredChildren } : null;
}

function filterSection(section, loweredInput, values, filteredValues) {
  const filteredChildren = section.children
    .map(filter => includeFilter(filter, loweredInput, values, filteredValues))
    .filter(x => x);

  // If we only have a hit on the section name, we display the
  // whole section but with the expansion intact.
  if (
    filteredChildren.length === 0 &&
    section.name.toLowerCase().indexOf(loweredInput) >= 0
  ) {
    return { ...section };
  }

  return filteredChildren.length > 0
    ? { ...section, children: filteredChildren }
    : null;
}

export function* handleSearchActions(action) {
  switch (action.type) {
    case FILTER_RECEIVE:
    case PROPERTY_SEARCH_ACTION: {
      const { inputValue, lastInputValue } = yield select(getInputValues);
      const inputFilter = yield select(getFilter);

      if (inputValue.length < 2) {
        if (action.type === FILTER_RECEIVE || lastInputValue.length > 1) {
          yield put(
            propertySearchComplete(
              inputFilter.core,
              inputFilter.definition,
              inputFilter.values
            )
          );
        }
        return;
      }

      const loweredInput = inputValue.toLowerCase();
      const { values, core, definition } = inputFilter;

      // In order to not rewrite the values object,
      // create a new one and fill with values we need
      const filteredValues = {};

      const filteredCore = core
        .map(filter =>
          includeFilter(filter, loweredInput, values, filteredValues)
        )
        .filter(x => x);

      const filteredSections = definition
        .map(section =>
          filterSection(section, loweredInput, values, filteredValues)
        )
        .filter(x => x);

      yield put(
        propertySearchComplete(filteredCore, filteredSections, filteredValues)
      );

      break;
    }
    default:
      break;
  }
}

function* mySaga() {
  yield takeEvery(
    [PROPERTY_SEARCH_ACTION, FILTER_RECEIVE],
    handleSearchActions
  );
}

export default mySaga;
